import {
	LOAD_USER_DATA,
	UPDATE_USER,
	NEW_USER,
	SELECTED_USER,
	DE_SELECTED_USER,
	UPDATE_USER_MODIFIED_TIME,
	LOAD_SENDER_LIST,
	SET_TO_INITIAL_STATE
} from '../actions/user.action';
import { IActionBase } from '../models/root.interface';
import { UsersInterface, User, ServicesInterface, CurrentSessionInterface } from '../models/conversation.interface';
import { normalizeData } from '../../utils';
import get from 'lodash/get';
import * as moment from 'moment';
import map from 'lodash/map';
import remove from 'lodash/remove';
import uniqBy from 'lodash/uniqBy';

const initialState: UsersInterface = {
	byId: {},
	allIds: [],
	selectedUser: {
		// id: '',
		company_id: '',
		user_id: '',
		display_name: '',
		services: {} as ServicesInterface,
		to_identifier: '',
		agent_name: '',
		created_at_ts: '',
		modified_at_ts: '',
		replied_at: '',
		current_session: {} as CurrentSessionInterface
	},
	senderList: {
		sms: [],
		whatsapp: []
	}
};

const getSortedUsers = (users: User[]) => {
	return users.sort((a, b) => {
		let start = get(b, 'modified_at_ts');
		let end = get(a, 'modified_at_ts');
		// if (isEmpty(start)) {
		// 	start = get(b, 'created_at_ts');
		// }
		// if (isEmpty(end)) {
		// 	end = get(a, 'created_at_ts');
		// }
		return moment.default(start).diff(end);
	});
}

const getIdsByDate = (users: User[]): string[] => {
	const sortConversationByDate = getSortedUsers(users);
	return map(sortConversationByDate, (s) => s.to_identifier);
};

function usersReducer(
	state: UsersInterface = initialState,
	action: IActionBase
): UsersInterface {
	switch (action.type) {
		case LOAD_USER_DATA:
			if (action.payload) {
				const newPayload = uniqBy([...Object.values(state.byId), ...action.payload], 'to_identifier');
				const sortedIds = getIdsByDate(newPayload);
				const normalizedUsers = normalizeData(newPayload, 'to_identifier');
				// let firstUserByDate = sortedIds[0];
				// if(state.selectedUser && state.selectedUser.identifier && state.selectedUser.identifier.length > 0 ){
				// 	firstUserByDate = state.selectedUser.identifier;
				// }
				return {
					...state,
					byId: { ...normalizedUsers },
					allIds: [...Object.keys(normalizedUsers)],
					allIdsByDate: [...sortedIds],
					// selectedUser: normalizedUsers[firstUserByDate],
				};
			} else {
				return state;
			}
		case SELECTED_USER:
			return {
				...state,
				selectedUser: {
					...state.selectedUser,
					...action.selectedUser,
				},
			};
		case UPDATE_USER:
			const { allIdsByDate } = state;
			if (allIdsByDate) {
				remove(allIdsByDate, (item) => { return item === action.userToUpdate.to_identifier });
				allIdsByDate.unshift(action.userToUpdate.to_identifier);
			}
			return {
				...state,
				allIdsByDate: allIdsByDate,
				byId: {
					...state.byId,
					[action.userToUpdate.to_identifier]: action.userToUpdate,
				},
			};
		case NEW_USER:
			//TODO: Do the sorting in component as it has to sort everytime it renders
			const newPayload2 = [...Object.values(state.byId), action.userToAdd];
			const sortedNewUserIds = getIdsByDate(newPayload2);
			return {
				...state,
				byId: {
					...state.byId,
					[action.userToAdd.to_identifier]: action.userToAdd,
				},
				allIds: [...state.allIds, action.userToAdd.to_identifier],
				allIdsByDate: [...sortedNewUserIds],
				// selectedUser: action.userToAdd,
			};
		case DE_SELECTED_USER:
			return {
				...state,
				selectedUser: initialState.selectedUser
			}
		case UPDATE_USER_MODIFIED_TIME:
			const allIdsByDates = state.allIdsByDate;
			if (allIdsByDates) {
				remove(allIdsByDates, (item) => { return item === action.updateTimeObj.to_identifier });
				allIdsByDates.unshift(action.updateTimeObj.to_identifier);
			}
			return {
				...state,
				allIdsByDate: allIdsByDates,
				byId: {
					...state.byId,
					[action.updateTimeObj.to_identifier]: {
						...state.byId[action.updateTimeObj.to_identifier],
						modified_at: action.updateTimeObj.modified_at
					},
				},
			}
		case LOAD_SENDER_LIST:
			return {
				...state,
				senderList: action.senderList
			}
		case SET_TO_INITIAL_STATE:
			return {
				...initialState,
				senderList: state.senderList
			}
		default:
			return state;
	}
}

export default usersReducer;
